import { controls, grouped } from "../controls";
import React, { Component } from 'react';

const tr008 = {
  label: "Cash Receipt",
  pageLabel: "Cash Receipt",
  starting: true,
  url: "cr",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [
    ...grouped.trnsummary(),
    {
      widths: "col-sm-9",
      tab: "create",
      style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
      direction: 'vertical',
      pagination: { perPage: 30, buttonSize: 'col-sm-2' },
      subComponents: [
        {
          widths: "col-sm-12",
          tab: "create",
          title: "Transaction Information",
          style: { paddingLeft: 0, paddingRight: 0 },
          direction: 'vertical',
          pagination: { perPage: 30, buttonSize: 'col-sm-2' },
          subComponents: [
            {
              widths: "col-sm-9",
              tab: "create",
              style: { border: 0, paddingLeft: 0, paddingRight: 0 },
              direction: 'vertical',
              pagination: { perPage: 30, buttonSize: 'col-sm-2' },
              subComponents: [

                ...controls.displayText({ label: "Ac No", width: "col-sm-2" }),
                ...controls.oc({ tab: "filter", width: "col-sm-3", length: 4, c: "Account", placeHolder: "Ac No", name: "account_code", fastpath: "ms201" }),

                ...controls.showData({ data: "account_display", width: "col-sm-7" }),
                ...controls.displayText({ label: "Amount", width: "col-sm-2" }),

                ...controls.numtoword({
                  name: "entered_amount",
                  width: "col-sm-3",
                  textwidth: "col-sm-7",
                  onRender: [
                    // calculate withdrawable - amount
                    { f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'pageData.withdrawable' }, { source: 'pageData.entered_amount', mult: { source: "pageData.cdflag", condition: { debit: -1 } } }], resultVar: 'new_balance' },
                    // set parent state, for new balance
                    { f: 'setParentState', inputs: { dest: "pageData.new_balance", source: 'allResults', field: 'new_balance' }, resultVar: "maturity_amount" },
                  ],
                  parents: [
                    {
                      name: 'amountReadOnly',
                      match: "in",
                      value: [true],
                      reverse: true
                    }
                  ]
                }),


                ...controls.displayText({ label: "Instru No", width: "col-sm-2" }),
                ...controls.numberOnly({ name: "inst_no", width: "col-sm-3" }),

                ...controls.displayText({ label: "", width: "col-sm-7" }),

                ...controls.displayText({
                  style: { textAlign: 'right' }, label: "Charges", width: "col-sm-2", style: { color: "orange" },
                  parents: [
                    {
                      name: "isCloseAccount",
                      match: "exist",
                    }
                  ]
                }),

                ...controls.showData({
                  data: "entered_charges_text", width: "col-sm-7", style: { fontSize: 14 }, parents: [
                    {
                      name: "isCloseAccount",
                      match: "exist",
                    }
                  ]
                }),

                ...controls.displayText({ label: "Particulars", width: "col-sm-2" }),
                ...controls.text({ name: "particulars", width: "col-sm-6" }),


                ...controls.button({
                  label: "Add",
                  onclick: {
                    action: [
                      { act: "unlockAccountNumber", sendToServer: { dataType: "unlockAcNo", sendData: ['branch_guid', 'account_number'] } },
                      { act: "appendToHTMLTable" }
                    ],
                    tableNameField: 'transaction_grid',
                    requiredField: ["product_code_display", "product_code", "account_number", "account_number_display", "cdflag", "entered_amount", "particulars", "new_balance"],
                    removeExcept: ['branch_code', 'branch_display', 'branch_guid', 'as_on_date', 'batch_no', 'total_credit', 'total_debit', 'final_amount', 'cdflag'],
                  },
                  width: "col-sm-2",
                  style: { padding: 0 },
                  Bcolor: "success"
                }),
                ...controls.button({
                  label: "Clear", onclick: {
                    action: [
                      { act: "unlockAccountNumber", sendToServer: { dataType: "unlockAcNo", sendData: ['branch_guid', 'account_number'] } }, { act: "clearHTMLTableForm" }
                    ],
                    tableNameField: 'transaction_grid',
                    requiredField: ["product_code_display", "product_code", "product_code_guid", "account_number", "account_number_display", "cdflag", "entered_amount", "particulars", "new_balance"],
                    removeExcept: ['branch_code', 'branch_display', 'branch_code_guid', 'as_on_date', 'batch_no', 'total_credit', 'total_debit', 'final_amount', 'cdflag'],
                  }, width: "col-sm-2",
                  style: { padding: 0 },
                }),

              ]
            },
            {
              widths: "col-sm-3",
              tab: "create",
              style: { border: 0, paddingLeft: 0, paddingRight: 0 },
              direction: 'vertical',
              pagination: { perPage: 30, buttonSize: 'col-sm-2' },
              subComponents: [
                ...controls.displayImage({ name: "acphotos" })
              ]
            },

            {
              inputType: "table",
              tableTitle: "",
              isRequired: true,
              editable: false,
              deletable: false,
              copyable: false,
              toggledropdown: true,
              togglebutton: [{ label: 'Edit', editable: false, }, { label: 'Delete', deletable: false, }],
              tableHeaders: [
                { label: "Sr", type: "autoinc" },
                { label: "GL Code", field: "product_code" },
                { label: "GL Name", field: "product_code_display" },
                { label: "Ac Code", field: "account_number" },
                { label: "Ac Name", field: "account_number_display" },
                { label: "C/D", field: "cdflag" },
                { label: "Amount", field: "entered_amount", displaytype: 'currency' },
                { label: "Particulars", field: "particulars" },
                { label: "Balance", field: "new_balance", displaytype: 'currency' },
              ],
              widths: {
                parent: "col-sm-12",
                children: "col-sm-12"
              },
              description: "Transaction Grid",
              name: "transaction_grid",
              onRender: [
                { f: 'tableCalculations', calcType: 'sum', inputs: { source: 'pageData.transaction_grid', field: 'entered_amount', filter: { cdflag: 'credit' } }, resultVar: 'totalCredit' },
                { f: 'setParentState', inputs: { dest: "pageData.total_credit", source: 'allResults', field: 'totalCredit' }, resultVar: "totalCreditT" },
                { f: 'tableCalculations', calcType: 'sum', inputs: { source: 'pageData.transaction_grid', field: 'entered_amount', filter: { cdflag: 'debit' } }, resultVar: 'totalDebit' },
                { f: 'setParentState', inputs: { dest: "pageData.total_debit", source: 'allResults', field: 'totalDebit' }, resultVar: "totalDebitT" },
                { f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'allResults', field: 'totalCredit' }, { source: 'allResults', field: 'totalDebit', mult: { source: "fixed", field: 'mult', fixed: { mult: -1 } } }], resultVar: 'total' },
                { f: 'setParentState', inputs: { dest: "pageData.final_amount", source: 'allResults', field: 'totalDebit' }, resultVar: "totalDebitT" },
              ]
            }
          ]
        },

      ]
    },
    grouped.acinfo('create')

  ]
}

export default tr008;